export enum TABLE_VIEW_CONTENT {
    Initial = "initial",
    Columns = "columns",
    Rows = "rows"
}
